import script from "./SharingLimitModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SharingLimitModal.vue?vue&type=script&lang=ts&setup=true"

import "./SharingLimitModal.vue?vue&type=style&index=0&id=08f5be85&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f5be85"]])

export default __exports__